import React from 'react';

const dropDown = (props) => {
	let fieldDetail = JSON.parse(props.fieldDetails);
	let dispContent = fieldDetail.options.map((arr,i) => {
		return (
			<option key={i} value={arr.value}>{arr.name}</option>
		);
	});
	return (
    	<select className={fieldDetail.classname + ' select2'} name={props.fieldKey} onChange={props.changed} value={fieldDetail.value} disabled={fieldDetail.disabled}>
    		{dispContent}
     	</select>
	);
}

export default dropDown;

/*
let kvArray = [{key: 1, value: 10}, 
               {key: 2, value: 20}, 
               {key: 3, value: 30}]

let reformattedArray = kvArray.map(obj => {
   let rObj = {}
   rObj[obj.key] = obj.value
   return rObj
})*/